function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPublic = function SvgPublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22384"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20088",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17777",
    d: "M3.049 10.111h1.729a1.778 1.778 0 0 1 1.778 1.778v.889a1.778 1.778 0 0 0 1.778 1.778 1.778 1.778 0 0 1 1.778 1.778v2.618M7.444 3.831v1.391a2.222 2.222 0 0 0 2.223 2.222h.444a1.778 1.778 0 0 1 1.778 1.778 1.778 1.778 0 1 0 3.556 0 1.778 1.778 0 0 1 1.778-1.778h.946m-4.5 11.1v-2.211a1.778 1.778 0 0 1 1.778-1.778h2.724M19 11a8 8 0 1 1-8-8 8 8 0 0 1 8 8Z",
    transform: "translate(1.5 1.5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgPublic;